import Vue from 'vue';

export default Vue.component('logout', {
  created() {
    this.$cookies.remove('accessToken');
    this.$router.push('/login');
  },
  render: () => '<div></div>',
});
